import {
  FATHER, FATHER_IN_LAW, MOTHER, MOTHER_IN_LAW
} from 'constants/enums/relationshipOptions';
import { locationIsEmpty } from 'models/validate';
import * as form from '../form';

export const relationshipsRelatives = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};

    return {
      Item: {
        Relation: form.radio(xitem.Relation),
        PvqRelation: form.radio(xitem.PvqRelation), // pvq only
        PvqEmployerRelationship: form.radio(xitem.PvqEmployerRelationship), // pvq only
        PvqOtherGovtAgencyExplanation: form.textarea(xitem.PvqOtherGovtAgencyExplanation), // pvq only
        NoContactWithFamily: form.checkbox(xitem.NoContactWithFamily), // pvq only
        CitizenshipStatus: form.radio(xitem.CitizenshipStatus), // pvq only
        Residency: form.radio(xitem.Residency), // pvq only
        AlienNumber: form.text(xitem.AlienNumber), // pvq only
        CertificateNumber: form.text(xitem.CertificateNumber), // pvq only
        InContact: form.branch(xitem.InContact), // pvq only
        RelativeOccupation: form.text(xitem.RelativeOccupation), // pvq only
        BirthdateNotApplicable: form.notapplicable(xitem.BirthdateNotApplicable), // pvq only
        BirthplaceNotApplicable: form.notapplicable(xitem.BirthplaceNotApplicable), // pvq only
        RelativeRelationshipNotApplicable: form.notapplicable(xitem.RelativeRelationshipNotApplicable), // pvq only
        AffiliationNotApplicable: form.notapplicable(xitem.AffiliationNotApplicable), // pvq only
        DeceasedNotApplicable: form.notapplicable(xitem.DeceasedNotApplicable), // pvq only
        Name: form.name(xitem.Name),
        Birthdate: form.datecontrol(xitem.Birthdate),
        Birthplace: form.location(xitem.Birthplace),
        Citizenship: form.country(xitem.Citizenship),
        CitizenshipDocumentation: form.radio(xitem.CitizenshipDocumentation),
        OtherCitizenshipDocumentation: form.textarea(xitem.OtherCitizenshipDocumentation),
        MaidenSameAsListed: form.branch(xitem.MaidenSameAsListed),
        MaidenName: form.name(xitem.MaidenName),
        Aliases: form.collection(
          ((xitem.Aliases || {}).items || []).map((y) => {
            const yitem = y.Item || {};
            return {
              Item: {
                Has: form.branch(yitem.Has),
                Name: form.name(yitem.Name),
                MaidenName: form.branch(yitem.MaidenName),
                Dates: form.daterange(yitem.Dates),
                Reason: form.textarea(yitem.Reason),
                Comments: form.textarea(yitem.Comments),
                NameOptions: form.radio(yitem.NameOptions), // pvq only
                NameOptionsExplanation: form.textarea(yitem.NameOptionsExplanation), // pvq only
              },
            };
          })
        ),
        IsDeceased: form.branch(xitem.IsDeceased),
        Address: form.location(xitem.Address),
        AlternateAddress: form.physicaladdress(xitem.AlternateAddress),
        AlternateAddressNotApplicable: (
          xitem.AlternateAddressNotApplicable?.applicable !== undefined ? form.notapplicable(xitem.AlternateAddressNotApplicable) : form.notapplicable({ applicable: true }) // eslint-disable-line max-len
        ),
        AlternateAddressExplanation: form.textarea(xitem.AlternateAddressExplanation),
        DocumentNumber: form.text(xitem.DocumentNumber),
        CertificateNumberNotApplicable: form.notapplicable(xitem.CertificateNumberNotApplicable), // pvq only
        CourtName: form.text(xitem.CourtName),
        CourtNameNotApplicable: form.notapplicable(xitem.CourtNameNotApplicable), // pvq only
        CourtAddress: !locationIsEmpty(xitem.CourtAddress, true) ? form.location(xitem.CourtAddress) : form.location({}),
        Document: form.radio(xitem.Document),
        DocumentComments: form.textarea(xitem.DocumentComments),
        ResidenceDocumentNumber: form.text(xitem.ResidenceDocumentNumber),
        Expiration: form.datecontrol(xitem.Expiration),
        ExpirationUnknown: form.notapplicable(xitem.ExpirationUnknown), // pvq only
        ExpirationNotApplicable: form.notapplicable(xitem.ExpirationNotApplicable), // pvq only
        FirstContact: form.datecontrol(xitem.FirstContact),
        LastContact: form.datecontrol(xitem.LastContact),
        Methods: form.checkboxgroup(xitem.Methods),
        MethodsComments: form.textarea(xitem.MethodsComments),
        Frequency: form.radio(xitem.Frequency),
        FrequencyExplanation: form.textarea(xitem.FrequencyExplanation), // pvq only
        FrequencyComments: form.radio(xitem.FrequencyComments),
        DocumentNumberNotApplicable: (
          xitem.DocumentNumberNotApplicable?.applicable !== undefined ? form.notapplicable(xitem.DocumentNumberNotApplicable) : form.notapplicable({ applicable: true }) // eslint-disable-line max-len
        ),
        NoDocumentNumber: form.checkbox(xitem.NoDocumentNumber), // PVQ Only
        DocumentNumberExplanation: form.textarea(xitem.DocumentNumberExplanation),
        EmployerNotApplicable: form.notapplicable(xitem.EmployerNotApplicable),
        EmployerAddressNotApplicable: form.notapplicable(xitem.EmployerAddressNotApplicable),
        InUsaNotApplicable: form.notapplicable(xitem.InUsaNotApplicable),
        EmployerRelationshipNotApplicable: form.notapplicable(xitem.EmployerRelationshipNotApplicable),
        Employer: form.text(xitem.Employer),
        EmployerAddress: form.location(xitem.EmployerAddress),
        HasAffiliation: form.branch(xitem.HasAffiliation),
        EmployerRelationship: form.textarea(xitem.EmployerRelationship),
        EntryComments: form.textarea(xitem.EntryComments),
        EntryExplanation: form.textarea(xitem.EntryExplanation),
        ParentNotApplicable: xitem.ParentNotApplicable?.applicable !== undefined
          && [FATHER, MOTHER, FATHER_IN_LAW, MOTHER_IN_LAW].includes(xitem.Relation?.value)
          ? form.notapplicable(xitem.ParentNotApplicable) : form.notapplicable({ applicable: true }),
        MothersMaidenNameComments: form.textarea(xitem.MothersMaidenNameComments),
        AliasesComments: form.textarea(xitem.AliasesComments),
        AliasesSummaryComments: form.textarea(xitem.AliasesSummaryComments),
        DeceasedComments: form.textarea(xitem.DeceasedComments),
        ForeignRelativeComments: form.textarea(xitem.ForeignRelativeComments),
        OptionalComments: form.textarea(xitem.OptionalComments),
        EmployerComments: form.textarea(xitem.EmployerComments),
        HasAffiliationComments: form.textarea(xitem.HasAffiliationComments),
        ForeignAffiliationComments: form.textarea(xitem.ForeignAffiliationComments),
        AnswerComments: form.textarea(xitem.AnswerComments),
        AddressComments: form.textarea(xitem.AddressComments),
        PhysicalLocationComments: form.textarea(xitem.PhysicalLocationComments),
        AddressNotApplicable: form.notapplicable(xitem.AddressNotApplicable),
        AddressExplanation: form.textarea(xitem.AddressExplanation),
        CourtAddressNotApplicable: form.notapplicable(xitem.CourtAddressNotApplicable),
        CourtAddressExplanation: form.textarea(xitem.CourtAddressExplanation),
        FirstContactNotApplicable: form.notapplicable(xitem.FirstContactNotApplicable),
        FirstContactExplanation: form.textarea(xitem.FirstContactExplanation),
        CitizenshipCountryNotApplicable: form.notapplicable(xitem.CitizenshipCountryNotApplicable), // pvq only
        HasRelativeAffiliations: form.collection( // pvq only
          ((xitem.HasRelativeAffiliations || {}).items || []).map((z) => {
            const zitem = z.Item || {};
            return {
              Item: {
                Has: form.branch(zitem.Has),
                ExplanationNotApplicable: form.notapplicable(zitem.ExplanationNotApplicable), // pvq only
                Explanation: form.textarea(zitem.Explanation), // pvq only
              },
            };
          })
        ),
        ParentCitizenshipStatusNotApplicable: form.notapplicable(xitem.ParentCitizenshipStatusNotApplicable),
        NeverWorked: form.checkbox(xitem.NeverWorked), // PVQ Only
      },
    };
  });
  return {
    List: form.collection(items, (data?.List || {}).branch),
    SummaryComments: form.textarea(data?.SummaryComments),
  };
};
